import {ToolbarItem} from "./ToolbarItem";
import {StateButtonItem} from "./StateButtonItem";
import ICONS from "../assets/ICONS";
import {EnabledButtonItem} from "./EnabledButtonItem";
import LinkButton from "./buttons/LinkButton";

interface ToolbarItemCreator { (): ToolbarItem }

export class ToolbarItemFactory {

    private predefinedItems: Map<string, ToolbarItemCreator> = new Map<string, ToolbarItemCreator>();

    constructor(items?: [string, ToolbarItemCreator][]) {
        this.initializePredefined();

        if(items){
            items.forEach(x => {
                this.predefinedItems.set(x[0], x[1]);
            });
        }
    }

    public create(name: string): ToolbarItem {
        if(this.predefinedItems.has(name)){
            return this.predefinedItems.get(name)();
        }
        return null;
    }

    private initializePredefined(){

        let items: [string, ToolbarItemCreator][] = [
            ['undo', () => new EnabledButtonItem(e => e.can().undo(), e => e.chain().focus().undo().run(), ICONS.undo)],
            ['redo', () => new EnabledButtonItem(e => e.can().redo(), e => e.chain().focus().redo().run(), ICONS.redo)],

            ['bold', () => new StateButtonItem(e => e.isActive('bold'), e => e.chain().focus().toggleBold().run(), ICONS.bold)],
            ['italic', () => new StateButtonItem(e => e.isActive('italic'), e => e.chain().focus().toggleItalic().run(), ICONS.italic)],
            ['underline', () => new StateButtonItem(e => e.isActive('underline'), e => e.chain().focus().toggleUnderline().run(), ICONS.underline)],
            ['strike', () => new StateButtonItem(e => e.isActive('strike'), e => e.chain().focus().toggleStrike().run(), ICONS.strike)],

            ['clear-style', () => new StateButtonItem(e => false, e => e.chain().focus().unsetAllMarks().run(), ICONS.clearStyle)],

            ['bullet-list', () => new StateButtonItem(e => e.isActive('bulletList'), e => e.chain().focus().toggleBulletList().run(), ICONS.bulletList)],
            ['ordered-list', () => new StateButtonItem(e => e.isActive('orderedList'), e => e.chain().focus().toggleOrderedList().run(), ICONS.numList)],

            ['align-left', () => new StateButtonItem(e => e.isActive({ textAlign: 'left' }), e => e.chain().focus().setTextAlign('left').run(), ICONS.textLeft)],
            ['align-center', () => new StateButtonItem(e => e.isActive({ textAlign: 'center' }), e => e.chain().focus().setTextAlign('center').run(), ICONS.textCenter)],
            ['align-right', () => new StateButtonItem(e => e.isActive({ textAlign: 'right' }), e => e.chain().focus().setTextAlign('right').run(), ICONS.textRight)],
            ['align-justify', () => new StateButtonItem(e => e.isActive({ textAlign: 'justify' }), e => e.chain().focus().setTextAlign('justify').run(), ICONS.textJustify)],

            ['link', () => new LinkButton()],



        ];

        items.forEach(v => {
            this.predefinedItems.set(v[0], v[1]);
        })
    }

}